<template>
  <div class="Introduction">  
    <div class="Introduction__block" v-if="is_block == 1">
      <div class="Introduction__block-top" ref="block1" v-html="trans('GLOBAL.block1')"/>  
      <div class="Introduction__block-bottom" ref="block2" v-html="trans('GLOBAL.block2')"/>  
    </div>
    <div class="Introduction__block" v-if="is_block == 2">
      <div class="Introduction__block-top" ref="block3" v-html="trans('GLOBAL.block3')"/>  
      <div class="Introduction__block-bottom" ref="block4" v-html="trans('GLOBAL.block4')"/>  
    </div>
    <div ref="block" class="Introduction__bottom Bottom">    
      <div ref="button" class="Button" @click="onClick()">
        <div v-if="is_block == 1">{{ trans('GLOBAL.continue') }}</div>
        <div v-if="is_block == 2">Let’s begin</div>
      </div>
    </div>
  </div> 
</template>

<script>

import gsap from "gsap"

export default {

  name: 'Introduction',
  data: ()=>({
    is_block: 1
  }),
  watch:{

    'is_block'(nw, od) {
      this.$nextTick(()=>{

        gsap.delayedCall(1.5, ()=> this.$store.commit('app/SYNC_AUDIO', 'block3'))

        gsap.from([ this.$refs.block3, this.$refs.block4 ], {
          duration: 2, 
          // scale: 0,
          ease: 'cubic.out', 
          stagger: 1,
          delay: .25, 
          opacity: 0,
          onComplete: ()=>{
            gsap.to(this.$refs.block, {
              duration: .5, 
              y: 0,
              ease: 'back.out', 
              delay: .1, 
              opacity: 1
            })
          }
        })

      })
    },

  },
  mounted() {

    // this.$parent.introCompleted()
    // return

    this.$nextTick(()=>{

      gsap.delayedCall(1.5, ()=> this.$store.commit('app/SYNC_AUDIO', 'block1'))

      gsap.from([ this.$refs.block1, this.$refs.block2 ], {
        duration: 2, 
        // scale: 0,
        ease: 'cubic.out', 
        stagger: 1,
        delay: .5, 
        opacity: 0
      })

      gsap.from(this.$refs.block, {
        duration: .5, 
        y: '+=100',
        ease: 'back.out', 
        delay: 3.5, 
        opacity: 0
      })

    })

    // this.$parent.introCompleted()
    // #241F3F
    
  },
  methods:{
    onClick() {

      this.$store.commit('app/SYNC_AUDIO', 'none')

      if(this.is_block == 1) {
        gsap.to(this.$refs.block, {
          y: '+=100',
          duration: .5, 
          ease: 'none', 
          opacity: 0, 
          delay: .2,
          onComplete: ()=>{
            this.is_block = 2
          }
        }) 
      }
      else { 
        
        gsap.to([ this.$refs.block, this.$refs.block3, this.$refs.block4 ], {
          duration: .25, 
          stagger: .25,
          ease: 'none',
          opacity: 0,
          delay: .2,
          onComplete: ()=>{
            this.$parent.introCompleted()
          }
        })
      }

    },
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Introduction
  position absolute
  top 0
  left 0
  color white
  width 100%
  height 100%
  display flex 
  flex-direction column
  justify-content flex-start
  align-items center
  z-index 20000

  &__block 
    height 80%
    display flex 
    flex-direction column
    align-items center
    justify-content center
    text-align center
    padding 0 10%
    font-family SpaceGrotesk
    font-size 1.19em
    line-height 1.38em

    &-top
      padding 48px 0 16px

    &-bottom 
      padding-top 16px

    & span 
      font-weight 900

  &__bottom
    position absolute
    bottom 0

</style>


